import {
  BrokerageCustomerSearchRequestQuery,
  CustomerDocumentSearchRequestQuery,
  CustomerSearchRequestQuery,
} from '@lio/api-types';
import { InsuredLocationsQueryParams } from '@services/customer/insuredLocations/insuredLocations.types';

export type PageLimitParams = {
  pageLimit?: string;
  pageOffset?: string;
  sort?: string;
};

export const customerQueryKey = {
  _customer: ['customer'],
  getCustomer: (customerId: string) => [...customerQueryKey._customer, customerId],
  searchCustomers: ({ pageLimit, pageOffset, sort, ...filters }: CustomerSearchRequestQuery) => [
    ...customerQueryKey._customer,
    'list',
    filters,
    { pageLimit, pageOffset, sort },
  ],
  searchBrokerageCustomers: (customerId: string, params?: BrokerageCustomerSearchRequestQuery) => [
    ...customerQueryKey._customer,
    customerId,
    'brokerage',
    params,
  ],
  _customerBrokerage: (customerId?: string) => [...customerQueryKey._customer, customerId, 'brokerage'],
  _customerContactInfo: (customerId?: string) => [...customerQueryKey._customer, customerId, 'contact-info'],
  _customerLocation: (customerId?: string) => [...customerQueryKey._customer, customerId, 'location'],
  getLocation: ({ customerId, locationId }: { customerId?: string; locationId: string }) => [
    ...customerQueryKey._customerLocation(customerId),
    locationId,
  ],
  searchLocations: ({ customerId, pageLimit, pageOffset, sort, ...filters }: InsuredLocationsQueryParams) =>
    [...customerQueryKey._customerLocation(customerId), 'list', filters, { pageLimit, pageOffset, sort }] as const,
  getBrokerageMetadata: ({ customerId }: { customerId?: string }) => [
    ...customerQueryKey._customerBrokerage(customerId),
    'metadata',
  ],
  getLocationMetadata: ({ customerId }: { customerId?: string }) => [
    ...customerQueryKey._customerLocation(customerId),
    'metadata',
  ],
  searchContactInfo: ({ customerId }: { customerId?: string }) => [
    ...customerQueryKey._customerContactInfo(customerId),
  ],
  _customerDocument: (customerId?: string) => [...customerQueryKey._customer, customerId, 'document'],
  searchCustomerDocuments: (customerId?: string, params?: CustomerDocumentSearchRequestQuery) =>
    [...customerQueryKey._customerDocument(customerId), 'list', params] as const,
  getDocumentCount: ({ customerId }: { customerId?: string }) => [
    ...customerQueryKey._customerDocument(customerId),
    'count',
  ],
  getNamedInsuredUpdateRequest: (customerId: string, policyId?: string) => [
    ...customerQueryKey._customer,
    customerId,
    'named-insured-update-request',
    { policyId },
  ],
  getStatusHistory: (customerId: string) => [...customerQueryKey._customer, customerId, 'status-history'],
};
